import { Component, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA ,MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig } from '@angular/material/legacy-dialog';
import { AppCacheService } from '../../../core/services/cache/app-cache.service';
import { CacheConstant } from '../../../core/constants/app.constant';
const converter = require('number-to-words');

@Component({
  selector: 'additional-confirm-subscription',
  templateUrl: './additional-confirm-subscription.component.html',
  styleUrls: ['./additional-confirm-subscription.component.scss']
})
export class AdditionalConfirmSubscriptionComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<AdditionalConfirmSubscriptionComponent>, private cache: AppCacheService,) { }
  websiteName: string = this.cache.get(CacheConstant.Env_Properties).theme;
  subscriptionDeliveryCount: string = this.cache.get(CacheConstant.Env_Properties).subscriptionDeliveryCount
  deliveryCountInWords: string;

  ngOnInit() {
    if(this.subscriptionDeliveryCount !=undefined && this.subscriptionDeliveryCount!=null){
      this.deliveryCountInWords = converter.toWords(this.subscriptionDeliveryCount)
    } 
  }

  openSubscriptionHelpPage(){
    window.open('/subscriptions-help?section=terms-and-conditions');
  }

  onClose() {
    this.dialogRef.close();
  }
}
